var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-wiki-splitter-view.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { until } from "lit/directives/until.js";
import { splitHtml } from "../html-text-splitter.js";
var XWikiSplitterView = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.value = new RXController(this, "");
  }
  render() {
    return xComponents(
      html`${until(
        (async () => {
          const chunks = await splitHtml(this.value.value);
          return html`
            <x-grid columns="1fr 1fr" space="md">
              ${chunks.map(
            (c, i) => html` <x-flex
                  ${css({
              backgroundColor: "rgba(0,0,0,0.1)",
              borderRadius: "10px"
            })}
                >
                  <x-flex padding="sm" ${css({ borderBottom: "1px solid rgba(0,0,0,0.1)" })}>
                    <x-text bold>Chunk ${i + 1}</x-text>
                  </x-flex>
                  <x-flex padding="sm">
                    <x-text ${css({ whiteSpace: "pre-wrap" })}>${c.text}</x-text>
                  </x-flex>
                  <x-flex padding="sm" ${css({ borderTop: "1px solid rgba(0,0,0,0.1)" })}>
                    <x-text ${css({ fontFamily: "monospace" })}> ${JSON.stringify(c.meta)}</x-text>
                  </x-flex>
                </x-flex>`
          )}
            </x-grid>
          `;
        })(),
        html`<x-loader></x-loader>`
      )}`
    );
  }
};
__decorateClass([
  property()
], XWikiSplitterView.prototype, "value", 2);
XWikiSplitterView = __decorateClass([
  customElement("x-wiki-splitter-view")
], XWikiSplitterView);
export {
  XWikiSplitterView
};
